import { alpha, makeStyles } from "@material-ui/core/styles";

const styles = makeStyles((theme) => ({
  IndivCardHead: {
    // fontSize: "14px",
    fontWeight: 500,
    color: "grey",
  },
  IndivCredDet: {
    fontSize: "16px",
    fontWeight: 600,
  },
  filterCards: {
    border: "1px solid #E2E8F0",
    fontSize: "14px",
    fontWeight: 500,
    display: "flex",
    justifyContent: "center",
    alignItems:"center",
    // textAlign: "center",
    // width: "100%",

    // color: "grey",
    padding: "10px",
    // paddingLeft: "15px",
    // paddingRight: "15px",
    borderRadius: "10px",
    // marginRight: "10px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#0a2472",
      color: "white",
    },
  },
  selectedCard: {
    backgroundColor: "#0a2472",
    color: "white",
  },

  historyLabel: {
    display: "flex",
    justifyContent: "space-between",
    fontFamily: "Red Hat Display",
    backgroundColor: "rgba(225, 225, 225, 0.3)",
    padding: "10px",
    width: "100%",
    borderRadius: "10px",
  },
  circle: {
    clipPath: "circle()",
    marginTop: "2px",
    // width: "20px",
    // height: "20px",
    backgroundColor: "#2B378D",
  },
  contentCenter: {
    justifyContent: "center",
  },
  iconStyle: {
    marginLeft: "20%",
    paddingTop: "10%",
    color: "#0AC23E",
  },
  iconExcStyle: {
    marginLeft: "20%",
    paddingTop: "10%",
    color: "#E49F17",
  },
  iconExcMoreStyle: {
    marginLeft: "20%",
    paddingTop: "10%",
    color: "#EB2B00",
  },
  fontStyle: {
    fontSize: "14px",
    fontWeight: 600,
    textAlign: "center",
    marginLeft:4,
    marginRight:4,
  },
  closeBtn: {
    fontSize: "16px",
    fontWeight: 500,
    textDecoration: "underline",
    display: "flex",
    justifyContent: "flex-end",
    color: "#2B378D",
    cursor: "pointer",
  },
}));

export default styles;
